import { Alert } from "react-bootstrap";
import { AlertMessage } from "../../shared/models/error.model";
import { useSnapshot } from "valtio";
import store from "../../rootStore";

interface MessageProps {
    marginTop?: string;
    isInModal?: boolean;
}

const Message = (props?: MessageProps) => {
    const { genericStore } = store;
    const { alerts } = useSnapshot(genericStore);
    if (!alerts || alerts.length == 0) return null;

    const marginTop = props?.marginTop ?? "0";
    const isInModal = props?.isInModal ?? false;

    return (
        <div className="mx-auto position-fixed top-0 start-0 text-center end-0 w-100" style={{ zIndex: isInModal ? 9999 : 999, maxWidth: "500px", marginTop: marginTop}}>
            {
            alerts.map((alert: AlertMessage) =>  
                <Alert key={alert.id} variant={"primary"} className={`bg-white fade alert rounded-pill alert-dismissible fade show alert ${alert.type == "success" ? "alert-success" : "alert-danger"} show w-100`} role="alert" >
                    {alert.message}
                </Alert>
             )}
        </div>
    )
};
  
export default Message;